import React from 'react';
import { Select, InputNumber, Button, Text } from '@clockout-dev/design-elements';
import { DeleteOutlined } from '@ant-design/icons';
import { FREE_ADVANCE_CONDITION_OPTIONS } from '../../../configuration.constants';
import RulesPanel from '../../../../common/rulesPanel/RulesPanel';
import EmptyState from '../../../../common/emptyState/EmptyState';
import styles from '../styles/feeStructureForm.module.scss';

function FreeAdvancesPanel({ rules = [], onAdd, onRemove, onUpdate }) {
    return (
        <RulesPanel
            onAdd={onAdd}
            addLabel="Add a free advance rule"
            emptyState={
                <EmptyState
                    title="No free advance rules yet"
                    description="Add a row to grant a number of free advances under a condition."
                />
            }
        >
            {rules.map((rule) => (
                <div key={rule.id} className={styles.ruleRow}>
                    <Text as="span" size="s" className={styles.ruleLabel}>First</Text>
                    <InputNumber
                        value={rule.count}
                        onChange={(value) => onUpdate(rule.id, 'count', value)}
                        min={1}
                        max={999}
                        controls={false}
                        className={`${styles.inlineNumberInput} ${styles.countField}`}
                    />
                    <Text as="span" size="s" className={styles.ruleLabel}>advances are free</Text>
                    <Text as="span" size="s" className={styles.ruleLabel}>at</Text>
                    <Select
                        size="large"
                        value={rule.condition}
                        options={FREE_ADVANCE_CONDITION_OPTIONS}
                        onChange={(value) => onUpdate(rule.id, 'condition', value)}
                        className={`${styles.select} ${styles.selectMd}`}
                    />
                    <Button
                        type="button"
                        size="s"
                        variant="text"
                        className={styles.deleteButton}
                        onClick={() => onRemove(rule.id)}
                    >
                        <DeleteOutlined />
                    </Button>
                </div>
            ))}
        </RulesPanel>
    );
}

export default FreeAdvancesPanel;
